/**
 * Notifications Module Routes (Story 1.1)
 */
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { ModuleRoutes } from "../types";

const ProviderManagement = lazy(() => import("@/modules/notifications/pages/ProviderManagement"));
const NotificationCenter = lazy(() => import("@/modules/notifications/pages/NotificationCenter"));
const RuleManagement = lazy(() => import("@/modules/notifications/pages/RuleManagement"));
const NotificationDashboard = lazy(
  () => import("@/modules/notifications/pages/NotificationDashboard")
);
const CommunicationLogViewer = lazy(
  () => import("@/modules/notifications/pages/CommunicationLogViewer")
);
const TemplateManagement = lazy(() => import("@/modules/notifications/pages/TemplateManagement"));
const TemplateEditorPage = lazy(() => import("@/modules/notifications/pages/TemplateEditorPage"));
const NotificationDLQPage = lazy(
  () => import("@/pages/notifications-center/NotificationDLQPage")
);
const NotificationCenterAdminPage = lazy(
  () => import("@/pages/admin/notifications/NotificationCenterAdminPage")
);
const CommunicationLogPage = lazy(
  () => import("@/pages/admin/notifications/CommunicationLogPage")
);
const ManagerDashboardPage = lazy(
  () => import("@/pages/admin/notifications/ManagerDashboardPage")
);

export const notificationsRoutes: ModuleRoutes = {
  moduleId: "notificacoes",
  basePath: "/notificacoes",
  routes: [
    {
      path: "/notificacoes",
      element: <Navigate to="/notificacoes/inbox" replace />,
    },
    {
      path: "/notificacoes/dashboard",
      element: <NotificationDashboard />,
      permission: { resource: "notifications", action: "dashboard:view" },
    },
    {
      path: "/notificacoes/historico",
      element: <CommunicationLogViewer />,
      permission: { resource: "notifications", action: "log:view" },
    },
    {
      path: "/notificacoes/inbox",
      element: <NotificationCenter />,
    },
    {
      path: "/notificacoes/provedores",
      element: <ProviderManagement />,
      permission: { resource: "notifications", action: "providers:manage" },
    },
    {
      path: "/notificacoes/regras",
      element: <RuleManagement />,
      permission: { resource: "notifications", action: "rules:manage" },
    },
    {
      path: "/notificacoes/templates",
      element: <TemplateManagement />,
      permission: { resource: "notifications", action: "templates:view" },
    },
    {
      path: "/notificacoes/templates/:id/editar",
      element: <TemplateEditorPage />,
      permission: { resource: "notifications", action: "templates:manage" },
    },
    {
      path: "/notificacoes/dlq",
      element: <NotificationDLQPage />,
      permission: { resource: "notifications", action: "admin" },
    },
    {
      // Story E1.7.2 — UI única que substitui as 6 sub-rotas v1.
      // Mantemos as sub-rotas existentes pra deep-links históricos não
      // quebrarem; admins acessam a tela nova por preferência.
      path: "/admin/notifications",
      element: <NotificationCenterAdminPage />,
      permission: { resource: "notifications", action: "providers:manage" },
    },
    {
      // Story E1.7.4 — log v2 que consulta notification_delivery, com
      // cursor pagination + filtros (provider/status/user/notification_id/date).
      path: "/admin/notifications/log",
      element: <CommunicationLogPage />,
      permission: { resource: "notifications", action: "log:view" },
    },
    {
      // Story E1.7.5 — Manager Dashboard com scope filter (lojas/setores).
      // Página separada do `/notificacoes/dashboard` (Story 3.2) para que
      // gestores possam escolher entre escopos que administram. Admin
      // também acessa — vê todo o tenant.
      path: "/notificacoes/gestor-dashboard",
      element: <ManagerDashboardPage />,
      permission: { resource: "notifications", action: "dashboard:view" },
    },
  ],
};
